import React, { Component } from 'react'

class UpdatePage extends Component {
  render () {
    return (
      <div>
        <h1>Updates</h1>
      </div>
    )
  }
}

export default UpdatePage



// WEBPACK FOOTER //
// ./src/components/updatepage.js